import React from "react";
import { Button } from "../Button/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function ConfirmActionDialog(props) {
  const {
    open,
    OKAction,
    onClose,
    message,
    title = "Confirm Action",
    OKText = "OK",
    cancelText = "Cancel",
    children,
  } = props;
  // onClose runs on both button clicks and should only set state so that the dialog
  // will close (i.e. `open` prop becomes falsy)
  const handleCancel = () => {
    onClose();
  };
  const handleOK = () => {
    onClose();
    OKAction();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {children || message}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: "8px 24px" }}>
        <Button onClick={handleCancel} variant="secondary">
          {cancelText}
        </Button>
        <Button onClick={handleOK} variant="primary" autoFocus>
          {OKText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
